<template>
  <div>

    <div class="my-profile section-group">
      <div class="row">
        <div class="group-set w-100">
          <div class="col-form-label f-weight">
            <p class="col-md-8 col-form-label"> {{ $t('Social.group.groupList.Settinggroups') }}</p>
            <el-select class="w-100" v-model="from.id" :placeholder="$t('Social.group.groupList.placeholder')" @change="selectChange" clearable>
              <el-option v-for="(item, ix) in groupnameList" :key="item.id" :label="item.sgL_GroupName" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 p-0">
          <div class="col-md-8 col-xs-12 content ">
            <div class="col-form-label f-weight"> {{ $t('Social.group.groupList.search_user') }}</div>
          </div>
          <div class="row justify-content-between">
            <div class="col d-flex px-0">
              <input type="text" class="me-2 col form-control" style="padding-left:15px" id="search_username"
                v-model="Search_user" :placeholder="$t('Social.group.groupList.search_user')">
              <button type="button" @click="handleCurrentUser(1)" class="mx-2 btn btn-primary" data-bs-toggle="collapse"
                href="#searchMember" role="button" aria-expanded="false" aria-controls="searchMember" :title="$t('Social.group.groupList.Searchinguserlist')"><i
                  class="fas fa-search"></i></button>
            </div>
            <div class="col px-0" style="text-align: end;">
              <button type="button" class="me-2 btn btn-primary" :title="$t('Social.group.groupList.Searchfriendlist')" @click="OpenModal()">{{ $t('Social.group.groupList.Searchfriendlist') }}</button>
            </div>
          </div>
          <!-- /.搜尋位置 -->

          <!-- 搜尋好友列表 -->
          <div class="modal fade" id="searchFriend" tabindex="-1" aria-labelledby="searchFriendLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title fs-5" id="searchFriendLabel">{{ $t('Social.group.groupList.friendlist') }}</h4>
                </div>
                <div class="modal-body">
                  <div class="d-flex py-1">
                    <input type="text" class="me-2 col form-control" v-model="Search_friends" id="search_username"
                      :placeholder="$t('Social.group.groupList.search_user')">
                    <button type="button" class="btn btn-primary" style="margin-left: 10px;" @click="Searchfriends()"
                      :title="$t('Social.group.groupList.Searchinguserlist')"><i class="fas fa-search"></i></button>
                  </div>

                  <!-- 搜尋用戶列表 -->
                  <div class="my-1" id="searchMember-two">
                    <div class="member-list"><b>{{ $t('Social.group.groupList.searchresult') }}</b></div>
                    <div class="member-list" v-for="(item, index) in Search_friends_list" :key="index">
                      <div>
                        <a href="#">{{ item.sgL_ToUsersName }}</a>
                      </div>
                      <div>
                        <input type="checkbox" :value="item.sgL_ToUsersId" v-model="FriendsOptions" aria-label="...">
                      </div>
                    </div>
                  </div>
                  <div class="row my-2">
                    <div class="col-12">
                      <pagination v-if="Search_friends_list.length > 0" :currentPage="pageParamsSearchFriends.currentPage"
                        :total="pageParamsSearchFriends.total" :limit="pageParamsSearchFriends.limit" :small="true"
                        :hide-on-single-page="true" :pageSizes="pageParamsSearchFriends.pageSizes"
                        @handleCurrentChange="handleCurrentSearchFriends" @handleSizeChange="handleSizeSearchFriends" />
                    </div>
                  </div>
                  <!-- ./搜尋用戶列表 -->

                  <div class="label-title">
                    <div class="form-label f-weight">
                      {{ `${$t('Social.group.groupList.friendlist')}(${Friends_List.length})` }}
                    </div>
                    <div class="form-label f-weight">
                      <div>
                        <input type="checkbox" v-model="FriendscheckAll" @click="checkedAll()" aria-label="...">
                      </div>
                    </div>
                  </div>
                  <div class="member-list" v-for="(item, index) in Friends_List" :key="index">
                    <div>
                      <a href="#">{{ item.sgL_ToUsersName }}</a>
                    </div>
                    <div>
                      <input type="checkbox" :value="item.sgL_ToUsersId" v-model="FriendsOptions" aria-label="...">
                    </div>
                  </div>
                  <div class="row my-2">
                    <div class="col-12">
                      <pagination v-if="Friends_List.length > 0" :currentPage="pageParamsFriends.currentPage"
                        :total="pageParamsFriends.total" :limit="pageParamsFriends.limit" :small="true"
                        :hide-on-single-page="true" :pageSizes="pageParamsFriends.pageSizes"
                        @handleCurrentChange="handleCurrentFriends" @handleSizeChange="handleSizeFriends" />
                    </div>
                  </div>

                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" style="margin: 4px;" @click="closeModal()">{{ $t('Social.group.groupList.cancel') }}</button>
                  <button type="button" class="btn btn-primary" style="margin: 4px;" @click="InviteGroup(null)"
                    data-bs-dismiss="modal"><i class="fas fa-user-plus">{{ $t('Social.group.groupList.Invitation') }}</i></button>
                </div>
              </div>
            </div>
          </div>
          <!-- ./搜尋好友列表 -->

          <!-- 搜尋用戶列表 -->
          <div class="content" id="searchMember">
            <div class="member-list"><b>{{ $t('Social.group.groupList.searchresult') }}</b><a @click="IsShow()" style="cursor: pointer;color:#26ad5e">{{ isShow ?
              $t('Social.group.groupList.packup') : $t('Social.group.groupList.unfold') }}</a></div>
            <div v-show="isShow">
              <div class="member-list" v-for="(item, index) in Search_User_List" :key="index">
                <div>
                  <a href="#">{{ item.displayName }}</a>
                </div>
                <div>
                  <button type="button" @click="InviteGroup([item.userId])" class="btn btn-primary"
                    data-bs-dismiss="modal"><i class="fas fa-user-plus">{{ $t('Social.group.groupList.Invitation') }}</i></button>
                </div>
              </div>
            </div>

          </div>
          <div class="row rowTop">
            <div class="col">
              <pagination v-if="Search_User_List.length > 0 && isShow" :currentPage="pageParamsUser.currentPage"
                :total="pageParamsUser.total" :limit="pageParamsUser.limit" :small="true" :hide-on-single-page="true"
                :pageSizes="pageParamsUser.pageSizes" @handleCurrentChange="handleCurrentUser"
                @handleSizeChange="handleSizeUSer" />
            </div>
          </div>
          <!-- ./搜尋用戶列表 -->

          <div class="content pt-4">
            <div class="label-title">
              <div class="form-label f-weight">
                {{ `${$t('Social.group.groupList.GroupUser')}(${Group_ListData.length}${$t('Social.group.groupList.a')})` }}
              </div>
              <div class="form-label f-weight">
                <div>
                  {{ $t('Social.group.groupList.batchoperation') }}
                  <button type="button" class="btn_icon btn_icon-primary" :title="$t('Social.group.groupList.Removegroup')"
                    @click="UpdateGroupMsgVideo(null, 'Remove')"><i class="fas fa-minus"></i></button>
                  <button type="button" class="btn_icon btn_icon-primary" :title="$t('Social.group.groupList.offsharing')"
                    @click="UpdateGroupMsgVideo(null, 'Video')"><i class="fas fa-video-slash"></i></button>
                  <button type="button" class="btn_icon btn_icon-primary" :title="$t('Social.group.groupList.Closemessages')"
                    @click="UpdateGroupMsgVideo(null, 'Msg')"><i class="fas fa-comment-slash"></i></button>
                  <input type="checkbox" id="checkboxNoLabel" v-model="GroupUsercheckAll" @click="GroupUsercheckedAll()"
                    class="input-general" value="" aria-label="...">
                </div>
              </div>
            </div>

            <div>
              <div class="member-list" v-for="(item, index) in Group_ListData" :key="index">
              <template >
                  <div>
                    <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': item.sgL_UsersId } }">{{
                      item.sgL_UsersName == null ? item.sgL_UpdateName :  item.sgL_UsersName }}</router-link>
                  </div>
                  <div v-if="item.sgL_UsersId !== $store.getters.getcustomer.userId">
                    <button type="button" class="btn_icon btn_icon-primary" :title="$t('Social.group.groupList.rem')"
                      @click="UpdateGroupMsgVideo(item, 'Remove')">
                      <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn_icon btn_icon-primary" :title="item.sgL_IsVideo ? $t('Social.group.groupList.msg1') : $t('Social.group.groupList.offsharing')"
                      @click="UpdateGroupMsgVideo(item, 'Video')">
                      <i class="fas" :class="{
                        'fa-video-slash': !item.sgL_IsVideo,
                        'fa-video': item.sgL_IsVideo,
                      }"></i>
                    </button>
                    <button type="button" class="btn_icon btn_icon-primary" :title="item.sgL_IsMessage ? $t('Social.group.groupList.Openmessage') : $t('Social.group.groupList.Closemessages')"
                      @click="UpdateGroupMsgVideo(item, 'Msg')">
                      <i class="fas" :class="{
                        'fa-comment-slash': !item.sgL_IsMessage,
                        'fa-comment': item.sgL_IsMessage,
                      }"></i>
                    </button>
                    <input type="checkbox" id="checkboxNoLabel" class="input-table" :value="item.sgL_UsersId"
                      v-model="GroupUserOptions" aria-label="...">
                  </div>
              </template>

              </div>
            </div>
          </div>
          <!-- /.朋友列表 -->
          <!-- 頁碼 -->
          <div class="row my-2">
            <div class="col-12">
              <pagination v-if="Group_ListData.length > 0" :currentPage="pageParams.currentPage" :total="pageParams.total"
                :limit="pageParams.limit" :small="true" :hide-on-single-page="true" :pageSizes="pageParams.pageSizes"
                @handleCurrentChange="handleCurrent" @handleSizeChange="handleSize" />
            </div>
          </div>
          <!-- /.頁碼 -->

        </div>
      </div>
    </div>
    <!-- /.My Profile -->

  </div>
</template>
<script>
import pagination from '@/components/common/Page'

export default {
  components: { pagination },
  data () {
    return {
      groupnameList: [],
      from: {
        id: ''
      },
      Group_ListData: [],
      isShow: false,
      Search_User_List: [],
      Friends_List: [],
      Search_friends_list: [],
      Search_friends: '',
      Search_user: '',
      pageParams: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageSizes: [10, 15, 20],
      },
      pageParamsUser: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageSizes: [10, 15, 20],
      },
      pageParamsFriends: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageSizes: [10, 15, 20],
      },
      pageParamsSearchFriends: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageSizes: [10, 15, 20],
      },
      isIndeterminate: true,
      FriendscheckAll: false,
      FriendsOptions: [],
      GroupUsercheckAll: false,
      GroupUserOptions: [],
    };
  },
  watch: { //深度 watcher
    'FriendsOptions': {
      handler: function (val, oldVal) {
        if (val.length === this.Friends_List.length && val.length !== 0) {
          this.FriendscheckAll = true;
        } else {
          this.FriendscheckAll = false;
        }
      },
      deep: true
    },
    'GroupUserOptions': {
      handler: function (val, oldVal) {
        if (val.length === this.Group_ListData.length) {
          this.GroupUsercheckAll = true;
        } else {
          this.GroupUsercheckAll = false;
        }
      },
      deep: true
    }
  },
  created () {
    this.GroupGetAll();
  },
  mounted () {

  },
  methods: {
    IsShow () {
      this.isShow = !this.isShow;
    },
    /**
     * @description : 
     * @author : 'Likc'
     * @param : '' 
     * @date : 2023-05-09 15:20:33
    */
    checkedAll () {
      var _this = this;
      if (_this.FriendscheckAll) { //实现反选
        _this.FriendsOptions = [];
      } else { //实现全选
        _this.FriendsOptions = [];
        _this.Friends_List.forEach(function (item, index) {
          _this.FriendsOptions.push(item.sgL_ToUsersId);
        });
      }
    },
    /**
     * @description : 
     * @author : 'Likc'
     * @param : '' 
     * @date : 2023-05-09 15:25:57
    */
    GroupUsercheckedAll () {
      var _this = this;
      if (_this.GroupUsercheckAll) { //实现反选
        _this.GroupUserOptions = [];
      } else { //实现全选
        _this.GroupUserOptions = [];
        _this.Group_ListData.forEach(function (item, index) {
          _this.GroupUserOptions.push(item.sgL_UsersId);
        });
      }
    },
    handleCurrentUser (val) {
      this.pageParamsUser.currentPage = val;
      this.SearchUser();
      this.isShow = true;
    },
    handleSizeUSer (val) {
      this.pageParamsUser.limit = val;
      this.pageParamsUser.currentPage = 1;
      this.SearchUser();
    },
    handleCurrent () {
      this.pageParamsUser.currentPage = val;
      this.GroupUsersAll();
    },
    handleSize () {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GroupUsersAll();
    },
    handleCurrentFriends (val) {
      this.pageParamsFriends.currentPage = val;
      this.FriendsGetAll();
    },
    handleSizeFriends (val) {
      this.pageParamsFriends.limit = val;
      this.pageParamsFriends.currentPage = 1;
      this.FriendsGetAll();
    },
    handleCurrentSearchFriends (val) {
      this.pageParamsSearchFriends.currentPage = val;
      this.Searchfriends();
    },
    handleSizeSearchFriends (val) {
      this.pageParamsSearchFriends.limit = val;
      this.pageParamsSearchFriends.currentPage = 1;
      this.Searchfriends();
    },
    async GroupUsersAll () {
      const { data: res } = await this.$api.social.GetFindUsersByGroupId({
        GroupId: this.from.id,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
      });
      if (!res.success) {
        this.$message({ type: "error", message: res.error.message });
        return;
      }
      this.Group_ListData = res.result.items;
      this.pageParams.total = this.Group_ListData.length;
    },
    GroupGetAll () {
      this.$api.social
        .GroupGetAll({
          SkipCount: 0,
          MaxResultCount: 9999999,
        })
        .then((res) => {
          this.groupnameList = res.data.result.items;
        });
    },
    selectChange () {
      if (this.from.id)
        this.GroupUsersAll();
    },

    //開啟關閉留言移除群組用戶
    async UpdateGroupMsgVideo (item, type) {
      let userid = item == null ? this.GroupUserOptions : [item.sgL_UsersId];
      if(userid.length == 0){
         this.$message.error('請選擇需要操作的數據');
         return;
      }
      const { data: res } = await this.$api.social.UpdateGroupMsgVideo({
        SGL_UserId: userid,
        SGL_GroupId: this.from.id,
        SGL_Type: type
      });
      if (res.success) {
        this.GroupUserOptions = [];
        this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
      } else
        this.$message({ type: "error", message: res.error.message });
      this.GroupUsersAll();
    },
    //打開群主好友列表
    OpenModal () {
      this.FriendsGetAll();
      this.FriendsOptions = [];
      $("#searchFriend").modal('show');
    },
    //邀請用戶入群組
    InviteGroup (userid) {
      if (!this.from.id) {
        this.$message.error('请选择群组')
        return
      }
      if(userid == null && this.FriendsOptions == []){
        this.$message.error('请选择數據')
        return
      }
      this.$api.social
        .InviteJoinGroups({
          userid: userid == null ? this.FriendsOptions : userid,
          GroupId: this.from.id
        })
        .then((res) => {
          const { data: e } = res;
          if (!e.success)
            this.$message.error(e.error.message);
          else {
            this.$message.success(this.$t('message.operatesuccessfully'));
            this.FriendsOptions = [];
          }

        });
    },
    //搜索好友彈出框的用戶
    Searchfriends () {
      this.$api.social
        .FriendsGetAll({
          SkipCount: (this.pageParamsSearchFriends.currentPage - 1) * this.pageParamsSearchFriends.limit,
          MaxResultCount: this.pageParamsSearchFriends.limit,
          displayName: this.Search_friends
        })
        .then((res) => {
          this.Search_friends_list = res.data.result.items;
          this.pageParamsSearchFriends.total = res.data.result.totalCount;
        });
    },
    FriendsGetAll () {
      this.$api.social
        .FriendsGetAll({
          SkipCount: (this.pageParamsFriends.currentPage - 1) * this.pageParamsFriends.limit,
          MaxResultCount: this.pageParamsFriends.limit,
        })
        .then((res) => {
          this.Friends_List = res.data.result.items;
          this.pageParamsFriends.total = res.data.result.totalCount;
        });
    },
    SearchUser () {
      if (!this.Search_user) {
        this.$message.warning('输入内容不能为空');
        return;
      }
      this.$api.social
        .FriendsFindUsers({
          displayName: this.Search_user,
          SkipCount:
            (this.pageParamsUser.currentPage - 1) * this.pageParamsUser.limit,
          MaxResultCount: this.pageParamsUser.limit,
        })
        .then((res) => {
          this.Search_User_List = res.data.result.items;
          this.pageParamsUser.total = res.data.result.totalCount;
        });
    },
    closeModal () {
      $("#searchFriend").modal('hide');
      this.Search_friends_list = [];
      this.Search_friends = '';
    }

  },
}
</script>

<style  scoped>
/* New list style */
.label-title {
  background: #26ad5e;
  padding: 5px 10px;
  color: #fff;
  border-radius: 3px;
  display: flex !important;
  justify-content: space-between;
}

.label-title .btn_icon {
  color: #fff;
}

.member-list {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  border-bottom: #dee2e6 1px solid;
}

.member-list:last-child {
  border-bottom: none;
}

#searchMember,
#searchMember-two {
  border: #dee2e6 1px solid;
  border-radius: 5px;
  margin-top: 20px;
}


.group-set {
  width: 100%;
}

/* ./Friend list */

/* Post */
.post-modal {
  max-width: 1200px;
  margin: auto;
  padding: 50px;
}

.post-modal .row {
  align-items: stretch;
}

.post-modal .feedpost-action {
  margin: 12px 0;
  border-bottom: 1px solid #ececec;
}

/* Post - Photo */
#feedback_photo_aj {
  display: grid;
  align-items: center;
  background: #000;
}

/* ./Post - Photo */

/* Post Comment */
.feedpost-content2 {
  padding-top: 10px;
}

.feedpost-comment-list {
  max-height: 50vh;
  overflow: auto;
}

/* ./Post Comment */


.nav-link {
  border: 0px;
  background: no-repeat;
  padding: 8px 16px;
  line-height: 24px;
}

/* Bookmark Play Button */
button.vjs-big-play-button {
  position: absolute;
  right: 35%;
  top: 50%;
  margin-left: -1.5em;
  background-color: rgba(0, 0, 0, .45);
  margin-top: -1em !important;
  border-radius: 10px;
  width: 60px;
  height: 44px !important;
  border: 1px solid #fff;
  color: #fff;
}

.rowTop>>>.el-pagination__total {
  color: black !important;
}

.rowTop>>>.el-pagination__jump {
  color: black !important;
}</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupList.vue